/**
 * JobEstimation have information about the job's cost estimation.
 */

import { PipelineProcess } from './pipeline-process';
import { PcvizUploadConfigData } from './PointCloudViz';

export interface JobEstimation {
    concurrentInstances: number;
    id: number;
    /** estimation about the cost of credits */
    processingCredits: number;
    /** estimation about the time */
    processingTime: number;
    processingUnits: number;
    unitsToCredits: number;
}

/**
 * Status which can have the jobs.
 */
export type JobStatus =
    | 'UPLOADING'
    | 'UPLOADED'
    | 'QUEUED'
    | 'PENDING'
    | 'PENDING_QUEUED'
    | 'RECEIVED'
    | 'STARTING'
    | 'STARTED'
    | 'PAUSED'
    | 'SUCCESS'
    | 'FAILURE'
    | 'REVOKED'
    | 'RUNNING_WITH_ERRORS'
    | 'SUCCESS_WITH_ERRORS'
    | 'RETRY'
    | 'CONNECTION_ERROR'
    | 'NOT_FOUND'
    | 'CANCELLED'
    | 'CANCELLING'
    | 'INCOMPLETE'
    | 'SELECTED'
    | 404;

export const JOB_STATUS_ERROR: JobStatus[] = ['FAILURE', 'REVOKED', 'CONNECTION_ERROR', 'NOT_FOUND', 'SUCCESS_WITH_ERRORS'];
export const JOB_STATUS_UPLOADING: JobStatus[] = ['UPLOADING', 'UPLOADED', 'PAUSED', 'QUEUED'];
export const JOB_STATUS_PROCESSING: JobStatus[] = ['PENDING', 'STARTING', 'STARTED'];
export const JOB_STATUS_FINISHED: JobStatus[] = ['FAILURE', 'SUCCESS', 'CANCELLED', 'SUCCESS_WITH_ERRORS'];
export const JOB_STATUS_CANCELLED: JobStatus[] = ['CANCELLED'];
export const JOB_STATUS_INCOMPLETE: JobStatus[] = ['INCOMPLETE'];

/**
 * Job model indicates which properties can have a job process.
 */
export interface Job extends PipelineProcess {
    id: number;
    processId: number;
    uploadJob: PcvizUploadConfigData;
    /** company id where is created */
    companyId: string;
    /** creation date */
    createdAt: Date;
    /** user id who create it */
    createdBy: number;
    /** indicates a job's cost estimation */
    estimation: JobEstimation;
    /** related jobs in a tree data structure */
    jobTree: Job[];
    jobTreeWithDetail?: any;
    process: number;
    upload: any;
    /** represents a JSON with the job's progress percentage information */
    progress: number | string | null;
    /** represents a JSON with the job's results object */
    result: string | null;
    /** seconds running */
    runtime: number | null;
    /** start date */
    startedAt: Date | null;
    /** string that indicates a job status */
    status: JobStatus;
    /** respresents a JSON with some information about the job's status */
    statusMessage: string | null;
    supportCompany: any;
    supportUser: any;
    /** resulting cost of the job */
    totalCost: string | null;
    inputData: string;
    files: JobFileInfo[];
    object: any;
}

export interface JobInputData {
    files: string[];
    filesInfo: any;
    fileSizes: number[];
    filter: string;
    jobTree: JobInputData[];
    upload: any;
}
export interface JobConfiguration {
    jobName: string | null;
    catalogId: string | null;
    projectUuid?: string | null;
}

export interface JobFileInfo {
    name: string;
    invalid?: boolean;
    invalidMessage?: string;
    size?: number;
    progress?: number;
}
